var map = {
	"./refundPolicy-de.vue": [
		"Kwyo",
		7
	],
	"./refundPolicy-en.vue": [
		"Sfrg",
		6
	],
	"./refundPolicy-es.vue": [
		"KsD3",
		5
	],
	"./refundPolicy-fr.vue": [
		"rYGY",
		4
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Od5u";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/pages/refundpolicy lazy ^\.\/refundPolicy\-.*\.vue$
// module id = Od5u
// module chunks = 17